import { Typography } from "@mui/material";
import "./SavedPrompts.css";
import { DeleteRounded, Info } from "@mui/icons-material";
import ConfirmationDialog from "../../../components/UI/ConfirmationDialog";
import { useState } from "react";

const SavedPrompts = ({ items, handleDeletePrompt, handleSelectPrompt }) => {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  return (
    <>
      <div className="item-list-container">
        <ul className="item-list">
          {items.map((item) => (
            <li
              key={item?._id}
              className="item-card"
              onClick={() => {
                handleSelectPrompt(item);
              }}
            >
              <DeleteRounded
                className="deleteIconInMenuItem"
                style={{
                  color: "grey",
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  zIndex: 1,
                }}
                onClick={() => {
                  setSelectedPrompt(item);
                  setShowConfirmationDialog(true);
                }}
              />
              {item?.exampleImageUrl ? (
                <div className="item-image-container">
                  <img
                    src={item?.exampleImageUrl || "/placeholder.svg"}
                    alt={item?.name || "Item image"}
                    className="item-image"
                  />
                </div>
              ) : (
                <div className="item-image-placeholder">No image available</div>
              )}

              <div className="item-details">
                <div className="item-name-container">
                  <Typography className="item-name">
                    {item?.name || "Unnamed Item"}
                  </Typography>
                  <div className="info-icon-container">
                    <Info color="primary" />
                    <div className="tooltip">{item.prompt}</div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <ConfirmationDialog
        title="Delete Confirmation"
        confirmButtonText="Delete"
        message={`Are you sure you want to delete "${
          selectedPrompt && selectedPrompt.name ? selectedPrompt.name : ""
        }"?`}
        show={showConfirmationDialog}
        onConfirm={() => {
          handleDeletePrompt(selectedPrompt?._id);
          setShowConfirmationDialog(false);
        }}
        onClose={() => {
          setShowConfirmationDialog(false);
        }}
      />
    </>
  );
};
export default SavedPrompts;
